import React from 'react';
import Popup from 'components/popups/popup';
import I18n from 'lib/i18n/i18n';
import RoundBTN from '../roundBTN';
import {MediumPrimaryButton} from "@worthy-npm/clarity";

class PopupTypeQtySelector extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.call(this, props);
    }
    constructor(props) {
        super(props);
        this.MAX_JB_ITEMS = 4;
        this.MIN_JB_ITEMS = 1;

        this.state = {
            quantity: this.props.quantity,
            moreThanMax: this.props.quantity >= this.MAX_JB_ITEMS,
            lessThanMin: this.props.quantity <= this.MIN_JB_ITEMS,
        };

    }
    title() {
        return I18n.getString('myAccount::popups::typeQtySelector::title').replace("{items}", this.props.plural);
    }

    content() {
        const subTitle = I18n.getString('myAccount::popups::typeQtySelector::subTitle').replace("{items}", this.props.pluralBody || this.props.plural)
        return (
            <div className="content">
                <div className="sub-title">{subTitle}</div>
                <div className="quantity-control">
                    <RoundBTN icon="&minus;" click={this.changeQuantity} clickVal={-1} disabled={this.state.lessThanMin}/>
                    <span className="quantity-indecation">
                        {this.state.quantity}
                        {this.state.moreThanMax ? (<i> + </i>) : null}
                    </span>
                    <RoundBTN icon="&#43;" click={this.changeQuantity} clickVal={1} disabled={this.state.moreThanMax}/>
                </div>
                <div className='submit-clarity-button-wrapper'>
                    <MediumPrimaryButton
                        click={(stopAnimation) => {
                            this.quantityChangeApproved()
                        }}
                        text={I18n.getString('myAccount::popups::typeQtySelector::submitForm')}
                        overrideWrapperCSS={{width: '100%'}}
                        overrideCSS={{backgroundColor: '#2D5DEC', borderRadius: '3px',
                            width: '100%', height: 'auto', padding: '11px 22px 12px',
                            font: '500 16px Roboto', color: '#fff', marginTop: '12px', textTransform: 'none'}}
                    />
                </div>
            </div>
        );
    }

    changeQuantity = (amount) => {
        const newQty = this.state.quantity + amount;
        if(newQty >= this.MIN_JB_ITEMS && newQty <= this.MAX_JB_ITEMS) {
            this.setState(() => ({
                quantity: newQty,
                moreThanMax: false,
                lessThanMin: false
            }));
        }
        else if (newQty > this.MAX_JB_ITEMS) {
            this.setState(() => ({moreThanMax: true}));
        }
        if (newQty <= this.MIN_JB_ITEMS) {
            this.setState(() => ({lessThanMin: true}));
        }
    }

    quantityChangeApproved = () => {
        this._hide.bind(this)();
        this.props.quantityChangeApproved(this.props.name ,this.state.quantity);
    }

    _hide() {
        super._hide();
    }
}

PopupTypeQtySelector.defaultProps = {
    popupClassName: 'popup-tooltip popup-compact qty-selector',
    classNames: ['no-animation']
};

export default PopupTypeQtySelector;